import { render, staticRenderFns } from "./allSchoolRecord.vue?vue&type=template&id=a98a9504"
import script from "./allSchoolRecord.vue?vue&type=script&lang=ts"
export * from "./allSchoolRecord.vue?vue&type=script&lang=ts"
import style0 from "./allSchoolRecord.vue?vue&type=style&index=0&id=a98a9504&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports